'use strict';

var widgetId = require('shared/widgetId'),
    messaging = require('shared/messaging'),

    messagingChannels = {};

module.exports = {
    store: store,
    storeFromGlobalMessageListenerParams: storeFromGlobalMessageListenerParams,
    get: get,
    destroy: destroy
};

function store(widgetId, channel) {

    _validateWidgetId(widgetId);
    _validateChannel(channel);

    messagingChannels[widgetId] = channel;
    return true;
}

function storeFromGlobalMessageListenerParams(widgetId, message, channel) {

    if (message && message.messageTitle === messaging.titles.READY) {
        store(widgetId, channel);
    }

    return false;
}

function get(widgetId) {
    return messagingChannels[widgetId] || null;
}

function destroy(widgetId) {
    delete messagingChannels[widgetId];
}

function _validateWidgetId(validationSubject) {
    if (!widgetId.isValid(validationSubject)) {
        throw new Error('iVis.Widget: widgetMessagingChannels.store arg[0] should be a valid widgetId');
    }
}

function _validateChannel(channel) {
    if (!(channel instanceof(MessagePort))) {
        throw new Error('iVis.Widget: widgetMessagingChannels.store arg[1] should be a valid MessagePort instance');
    }
}




//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/widgetMessagingChannels.js
// module id = 4
// module chunks = 0 1